import React, { useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './SearchBar.css';

const rotatingPlaceholders = [
  'Applications...',
  'Databases...',
  'Automation...',
  'AI...',
];

const SearchBar = ({ value, onChange, tags = [], selectedTag = 'All', onTagChange }) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % rotatingPlaceholders.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const showPlaceholder = !value;

  return (
    <div className="searchbar-wrapper">
      <div className="searchbar-container">
        {/* Show selected tag as chip inside input, styled the same as outside */}
        {selectedTag !== 'All' && (
          <button
            className="searchbar-chip"
            style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center' }}
            tabIndex={-1}
            type="button"
          >
            {selectedTag}
            <span
              className="searchbar-chip-close"
              onClick={() => onTagChange('All')}
              style={{ marginLeft: 4, cursor: 'pointer' }}
            >
              <CloseIcon fontSize="small" style={{ paddingTop: '4px' }} />
            </span>
          </button>
        )}
        <input
          type="text"
          value={value}
          onChange={onChange}
          className="searchbar-input"
          placeholder={showPlaceholder ? rotatingPlaceholders[index] : ''}
          style={{ marginLeft: selectedTag !== 'All' ? 8 : 0 }}
        />
        {/* Search Icon on the right */}
        <SearchIcon className="searchbar-icon" />
      </div>
      {/* Filter Chips Row */}
      <div className="searchbar-filters-row">
        {tags.map(tag => (
          <button
            key={tag}
            className={`searchbar-filter-btn${selectedTag === tag ? ' selected' : ''}`}
            onClick={() => onTagChange(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;